import React, { useState, useEffect } from 'react';
import { Link, NavLink } from 'react-router-dom';
import './Header.css';

const navLinks = [
  { to: '/', label: 'Forside' },
  { to: '/casino-guide', label: 'Casino Guide' },
  { to: '/vores-metode', label: 'Vores Metode' },
  { to: '/ansvarligt-spil', label: 'Ansvarligt Spil' },
  { to: '/om-os', label: 'Om Os' },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    if (menuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => { document.body.style.overflow = ''; };
  }, [menuOpen]);

  return (
    <header className={`site-header${scrolled ? ' scrolled' : ''}`}>
      <div className="header-notice">
        <span>&#9679; Kun for spillere over 18 år &nbsp;|&nbsp; Spil ansvarligt &nbsp;|&nbsp; <a href="https://www.rofus.nu/" target="_blank" rel="noopener noreferrer">ROFUS selvudelukkelse</a></span>
      </div>
      <div className="header-main container">
        <Link to="/" className="site-logo" onClick={() => setMenuOpen(false)}>
          <span className="logo-mark">TCD</span>
          <span className="logo-text">
            <span className="logo-name">TopCasinoDansk</span>
            <span className="logo-tagline">Uafhængig casino-guide til danske spillere</span>
          </span>
        </Link>

        <nav className={`site-nav${menuOpen ? ' open' : ''}`} aria-label="Primær navigation">
          <ul className="nav-list">
            {navLinks.map((link) => (
              <li key={link.to}>
                <NavLink
                  to={link.to}
                  end={link.to === '/'}
                  className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}
                  onClick={() => setMenuOpen(false)}
                >
                  {link.label}
                </NavLink>
              </li>
            ))}
          </ul>
          <div className="nav-mobile-footer">
            <Link to="/hjaelp" className="btn btn-outline btn-sm" onClick={() => setMenuOpen(false)}>Hjælp & Support</Link>
            <a href="https://www.stopspillet.dk/" target="_blank" rel="noopener noreferrer" className="nav-safety-link">StopSpillet.dk →</a>
          </div>
        </nav>

        <div className="header-actions">
          <Link to="/hjaelp" className="btn btn-outline btn-sm header-help-btn">Hjælp</Link>
          <button
            className={`burger${menuOpen ? ' active' : ''}`}
            aria-label={menuOpen ? 'Luk menu' : 'Åbn menu'}
            aria-expanded={menuOpen}
            onClick={() => setMenuOpen(!menuOpen)}
          >
            <span></span><span></span><span></span>
          </button>
        </div>
      </div>
      {menuOpen && <div className="mobile-overlay" onClick={() => setMenuOpen(false)} aria-hidden="true" />}
    </header>
  );
}
